import { Injectable } from '@angular/core';
import { config } from '../../../config/config';

@Injectable()
export class GoogleMapsConfig {
    public apiKey: string;
    public libraries: string[];
    public language: string;

    constructor() {
        this.apiKey = config.google.appKeys.getRandom();
        // console.log(`google key: ${this.apiKey}`);
        this.libraries = ['places'];
        this.language = 'en';
    }
}


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/app/google.maps.config.ts